import React, { useState, useEffect } from "react";
import { PickList } from "primereact/picklist";
import { toast } from "react-toastify";
import Axios from "../../../api/Axios";
import Loader from "../../../Components/Loader";
import storage from "../../../Services/Storage";

const url = "TCSApplicability/";
const GetAllTcs_url = `${url}GetAllTCSCustomer?`;
const GetDestination_url = `${url}GetDestinationTCSCustomer?`;
const GetSaveTcs_url = `${url}SaveTCSData`;

const TCSApplicability = () => {
    const auth = storage.getLocal("user");
    const [isLoading, setIsLoading] = useState(false);
    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    useEffect(() => {
        getAllTcs();
        getDestination();
    }, []);

    const getAllTcs = async () => {
        setIsLoading(true);
        try {
            const AllTcs_Url = `${GetAllTcs_url}CompId=${auth.CompId}`;
            const response = await Axios.get(AllTcs_Url);
            setSource(response.data.Data || []);
            setIsLoading(false);
        } catch (error) {
            handleError();
        }
    };

    const getDestination = async () => {
        setIsLoading(true);
        try {
            const Destination_Url = `${GetDestination_url}CompId=${auth.CompId}`;
            const response = await Axios.get(Destination_Url);
            setTarget(response.data.Data || []);
            setIsLoading(false);
        } catch (error) {
            handleError();
        }
    };

    const handleError = () => {
        toast.error("Something Went Wrong. Please Contact Helpdesk.", {
            position: toast.POSITION.TOP_CENTER,
            pauseOnFocusLoss: false,
            closeButton: false,
            autoClose: 3000,
        });
        setIsLoading(false);
    };

    const onChange = (event) => {
        setSource(event.source);
        setTarget(event.target);
    };

    const itemTemplate = (item) => {
        return <div>{item.CUSTOMER_NAME}</div>;
    };

    const handleSave = async () => {
        setIsLoading(true);
        try {
            const payload = {
                compId: auth.CompId,
                objDestinationCust: target.map((item) => ({
                    custID: item.CUSTOMER_ID,
                    custCode: item.CUSTOMER_CODE,
                    custName: item.CUSTOMER_NAME,
                })),
            };

            const response = await Axios.post(GetSaveTcs_url, payload);
            console.log(response);
            toast.success("Record Saved Successfully", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });

            setIsLoading(false);
        } catch (error) {
            console.log(error);
            handleError();
        }
    };

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">T.C.S. Applicability</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 text-end">
                            <button 
                                type="button" 
                                className="btn btn-primary" 
                                onClick={handleSave}
                            >
                Save
                            </button>
                        </div>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="PickListPanel sales-box">
                            <PickList
                                dataKey="CUSTOMER_ID"
                                source={source}
                                target={target}
                                breakpoint="768px"
                                itemTemplate={itemTemplate}
                                onChange={onChange}
                                filter
                                filterBy="CUSTOMER_NAME"
                                sourceHeader="Available Customers"
                                targetHeader="Selected Customers"
                                sourceStyle={{ height: "24rem" }}
                                targetStyle={{ height: "24rem" }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TCSApplicability;
